"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDeepFrozen = exports.deepFreeze = void 0;
// eslint-disable-next-line @typescript-eslint/no-var-requires
exports.deepFreeze = require('deep-freeze-strict');
const isDeepFrozen = (whatever) => {
    if (Array.isArray(whatever)) {
        return Object.isFrozen(whatever) || whatever.some((w) => (0, exports.isDeepFrozen)(w));
    }
    if (typeof whatever === 'object' && whatever) {
        return Object.isFrozen(whatever) || Object.values(whatever).some((v) => (0, exports.isDeepFrozen)(v));
    }
    // keep in mind that `Object.isFrozen` called on literals returns `true`
    return false;
};
exports.isDeepFrozen = isDeepFrozen;
//# sourceMappingURL=deepFreeze.js.map